import React, { useContext, useState, useEffect } from 'react'
import { Link, Redirect } from 'react-router-dom'
import { useHistory } from 'react-router-dom'
import { handleDeNorm, normalizePhone, deNormalizePhone, handleNorm } from '../../utils/functions/tools/normalizePhone';
import { sleep } from '../../utils/functions/tools/sleep';
const { REACT_APP_DEV_API_URL, REACT_APP_PROD_API_URL, NODE_ENV } = process.env;
const API_URL =
    NODE_ENV === 'production' ? process.env.REACT_APP_PROD_API_URL : process.env.REACT_APP_DEV_API_URL;

const AddProjects = ({ match }) => {

    const dateFormat = 'YYYY-MM-DD';
    const customFormat = value => `${value.format(dateFormat)}`;

    // Other Variables
    let [authTokens, setAuthTokens] = useState(() => localStorage.getItem('authTokens') ? JSON.parse(localStorage.getItem('authTokens')) : null)
    let [clients, setClients] = useState(null)

    const history = useHistory()

    useEffect(() => {
        getClients()
        document.title = "Add Project | WillowBMS"
    }, [])

    let getClients = async () => {
        let response = await fetch(`${API_URL}/client/list/`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + authTokens?.access
            }
        })
        let data = await response.json()
        setClients(data)
    }

    let createProject = async (values) => {
        let startDate = customFormat(values.startDate)
        let dueDate = customFormat(values.dueDate)
        let response = await fetch(`${API_URL}/project/add/`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + authTokens?.access
            },
            body: JSON.stringify({
                'name': values.name,
                'client': values.client,
                'status': values.status,
                'billingType': values.billingType,
                'rate': values.rate,
                'estimatedHours': values.estimatedHours,
                'description': values.description,
                'startDate': startDate,
                'dueDate': dueDate,
            })
        })
        let data = await response.json()
        let newProject = await JSON.parse(data)["newProject"]
        if (response.status === 200) {
            openSuccess('topRight')
            await sleep(2000)
            history.push(`/project/${newProject}`)
        } else {
            openError('topRight')
        }
    }

    const openSuccess = placement => {

    };

    const openError = placement => {

    };

    const validateMessages = {
        required: 'Field is required',
        types: {
            email: 'Please enter a valid email',
            number: 'Not a valid number',
        },
    };

    return (
        <></>
    )
}

export default AddProjects